<template>
  <!-- Header -->
  <div class="mb-1 p-2 pb-0">
    <Skeleton height="3rem"></Skeleton>
  </div>
  <!-- Map -->
  <div class="relative">
    <Skeleton height="calc(100svh - 3rem - 4px)"></Skeleton>
    <img
      id="image"
      src="/images/icons/restaurantPin.svg"
      alt="restaurant pin"
      class="absolute left-1/3 top-1/3 opacity-50"
    />
    <img
      id="image"
      src="/images/icons/restaurantPin.svg"
      alt="restaurant pin"
      class="absolute left-2/3 top-1/2 opacity-50"
    />
    <img
      id="image"
      src="/images/icons/restaurantPin.svg"
      alt="restaurant pin"
      class="absolute left-1/3 top-2/3 opacity-50"
    />
  </div>
</template>
